import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { EcliSettings } from '@models/settings.model';
import { StorageService } from '@services/storage.service';
import { BannerModel } from '@models/banner.model';
import { MarketingService } from '@services/marketing.service';
import { GS1SpinnerDirective } from '@gs1france/gs1-components-library';
import { TagsService } from '../../core/services/tags.service';

@Component({
  selector: 'app-home-banner',
  imports: [GS1SpinnerDirective],
  templateUrl: './home-banner.component.html',
  styleUrl: './home-banner.component.scss'
})
export class HomeBannerComponent {
  private storageService = inject(StorageService);
  private marketingService = inject(MarketingService);
  private tagsService = inject(TagsService);

  settings = toSignal<EcliSettings>(this.storageService.getSettings());
  banner = toSignal<BannerModel>(this.marketingService.getBanner());

  urlMarketing = computed<string>(() => {
    const settings = this.settings();
    return settings ? settings.values.UrlMarketing.defaultValue : null;
  });

  marketingBanner = computed<BannerModel>(() => {
    const banner = this.banner();
    return banner ? new BannerModel('data:image/png;base64,' + banner.base64, banner.url) : null;
  });

  naviagteToBannerUrl() {
    const banner = this.marketingBanner();
    if (banner && banner.url && banner.url !== 'null') {
      this.tagsService.sendEvent('banniere_marketing');
      window.open(banner.url);
    }
  }
}
